/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component } from 'react';


export default class RedirectComponent extends Component {

    constructor (props) {
        super(props);
    }

    componentDidMount(){
        const url = this.props.history.location.pathname.replace('redirect','digital-book');
        setTimeout(() => {
            this.props.history.push(url);
        },1000);
        
    }

    render() {
        return (
            <div className="redirect">
                <div className="loader"></div>
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/Redirect/RedirectComponent.js